import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    redirect: '/dashboard/analytics'
                },
                {
                    path: '/dashboard/analytics',
                    name: 'dashboard-analytics',
                    component: () => import('./views/DashboardAnalytics.vue'),
                    meta: {
                        authRequired: true,
                        rule: 'all'
                    }
                },
                // =============================================================================
                // BACKOFFICE ELEMENTS
                // =============================================================================
                {
                    path: '/users/list',
                    name: 'users-list',
                    component: () => import('@/views/users/UsersList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Usuários'},
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Usuários',
                        rule: 'admin'
                    }
                },
                {
                    path: '/categories/list',
                    name: 'categories-list',
                    component: () => import('@/views/categories/CategoriesList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cadernos'},
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Cadernos',
                        rule: 'all'
                    }
                },
                {
                    path: '/news/list',
                    name: 'news-list',
                    component: () => import('@/views/news/NewsList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Notícias'},
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Notícias',
                        rule: 'all'
                    }
                },
                {
                    path: '/news/create',
                    name: 'news-create',
                    component: () => import('@/views/news/NewsForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Notícias'},
                            { title: 'Adicionar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Adicionar Notícia',
                        rule: 'all'
                    }
                },
                {
                    path: '/news/edit/:id',
                    name: 'news-edit',
                    component: () => import('@/views/news/NewsForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Notícias'},
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Notícia',
                        rule: 'all'
                    }
                },
                {
                    path: '/newsletter/subscribers/list',
                    name: 'newsletter-subscribers-list',
                    component: () => import('@/views/newsletter/subscribers/SubscribersList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Newsletter'},
                            { title: 'Assinantes', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Newsletter - Assinantes',
                        rule: 'admin'
                    }
                },
                {
                    path: '/newsletter/templates/list',
                    name: 'newsletter-templates-list',
                    component: () => import('@/views/newsletter/templates/TemplatesList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Newsletter'},
                            { title: 'Templates', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Newsletter - Templates',
                        rule: 'admin'
                    }
                },
                {
                    path: '/newsletter/templates/create',
                    name: 'newsletter-templates-create',
                    component: () => import('@/views/newsletter/templates/TemplateForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Newsletter'},
                            { title: 'Templates'},
                            { title: 'Criar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Criar Template de Newsletter',
                        rule: 'admin'
                    }
                },
                {
                    path: '/newsletter/templates/edit/:id',
                    name: 'newsletter-templates-edit',
                    component: () => import('@/views/newsletter/templates/TemplateForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Newsletter'},
                            { title: 'Templates'},
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Template de Newsletter',
                        rule: 'admin'
                    }
                },
                {
                    path: '/newsletter/campaigns/list',
                    name: 'newsletter-campaigns-list',
                    component: () => import('@/views/newsletter/campaigns/CampaignsList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Newsletter'},
                            { title: 'Campanhas', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Newsletter - Campanhas',
                        rule: 'admin'
                    }
                },
                {
                    path: '/newsletter/campaigns/choose-template',
                    name: 'newsletter-campaigns-choose-template',
                    component: () => import('@/views/newsletter/campaigns/CampaignChooseTemplate.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Newsletter'},
                            { title: 'Campanhas'},
                            { title: 'Escolher Template', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Escolher Template para a Campanha',
                        rule: 'admin'
                    }
                },
                {
                    path: '/newsletter/campaigns/create',
                    name: 'newsletter-campaigns-create',
                    component: () => import('@/views/newsletter/campaigns/CampaignForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Newsletter'},
                            { title: 'Campanhas'},
                            { title: 'Criar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Criar Campanha de Newsletter',
                        rule: 'admin'
                    }
                },
                {
                    path: '/newsletter/campaigns/edit/:id',
                    name: 'newsletter-campaigns-edit',
                    component: () => import('@/views/newsletter/campaigns/CampaignForm.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Newsletter'},
                            { title: 'Campanhas'},
                            { title: 'Editar', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Editar Campanha de Newsletter',
                        rule: 'admin'
                    }
                },
                {
                    path: '/campaigns/list',
                    name: 'campaigns-list',
                    component: () => import('@/views/campaign-banners/CampaignBannersList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Campanhas'},
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Lista de Campanhas',
                        rule: 'admin'
                    }
                },
                {
                    path: '/newspaper-pdfs/list',
                    name: 'newspaper-pdfs-list',
                    component: () => import('@/views/newspaper-pdfs/NewspaperPdfsList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Jornal Digital'},
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Jornal Digital',
                        rule: 'all'
                    }
                },
                {
                    path: '/classifieds/list',
                    name: 'classifieds-list',
                    component: () => import('@/views/classifieds/ClassifiedsList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Classificados'},
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Classificados',
                        rule: 'all'
                    }
                },
                {
                    path: '/daily-covers/list',
                    name: 'daily-covers-list',
                    component: () => import('@/views/daily-covers/DailyCoversList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Capa do Dia'},
                            { title: 'Lista', active: true }
                        ],
                        authRequired: true,
                        pageTitle: 'Capa do Dia',
                        rule: 'all'
                    }
                },
                // =============================================================================
                // UI ELEMENTS
                // =============================================================================
                {
                    path: '/ui-elements/data-list/list-view',
                    name: 'data-list-list-view',
                    component: () => import('@/views/ui-elements/data-list/list-view/DataListListView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Data List'},
                            { title: 'List View', active: true }
                        ],
                        pageTitle: 'List View',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/data-list/thumb-view',
                    name: 'data-list-thumb-view',
                    component: () => import('@/views/ui-elements/data-list/thumb-view/DataListThumbView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Data List'},
                            { title: 'Thumb View', active: true }
                        ],
                        pageTitle: 'Thumb View',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/grid/vuesax',
                    name: 'grid-vuesax',
                    component: () => import('@/views/ui-elements/grid/vuesax/GridVuesax.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Grid'},
                            { title: 'Vuesax', active: true }
                        ],
                        pageTitle: 'Grid',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/grid/tailwind',
                    name: 'grid-tailwind',
                    component: () => import('@/views/ui-elements/grid/tailwind/GridTailwind.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Grid'},
                            { title: 'Tailwind', active: true }
                        ],
                        pageTitle: 'Tailwind Grid',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/colors',
                    name: 'colors',
                    component: () => import('./views/ui-elements/colors/Colors.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Colors', active: true }
                        ],
                        pageTitle: 'Colors',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/card/basic',
                    name: 'basic-cards',
                    component: () => import('./views/ui-elements/card/CardBasic.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Card' },
                            { title: 'Basic Cards', active: true }
                        ],
                        pageTitle: 'Basic Cards',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/card/statistics',
                    name: 'statistics-cards',
                    component: () => import('./views/ui-elements/card/CardStatistics.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Card' },
                            { title: 'Statistics Cards', active: true }
                        ],
                        pageTitle: 'Statistics Card',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/card/analytics',
                    name: 'analytics-cards',
                    component: () => import('./views/ui-elements/card/CardAnalytics.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Card' },
                            { title: 'Analytics Card', active: true }
                        ],
                        pageTitle: 'Analytics Card',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/card/card-actions',
                    name: 'card-actions',
                    component: () => import('./views/ui-elements/card/CardActions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Card' },
                            { title: 'Card Actions', active: true }
                        ],
                        pageTitle: 'Card Actions',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/card/card-colors',
                    name: 'card-colors',
                    component: () => import('./views/ui-elements/card/CardColors.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Card' },
                            { title: 'Card Colors', active: true }
                        ],
                        pageTitle: 'Card Colors',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/table',
                    name: 'table',
                    component: () => import('./views/ui-elements/table/Table.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Table', active: true }
                        ],
                        pageTitle: 'Table',
                        rule: 'all'
                    }
                },
                {
                    path: '/ui-elements/ag-grid-table',
                    name: 'ag-grid-table',
                    component: () => import('./views/ui-elements/ag-grid-table/AgGridTable.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'agGrid Table', active: true }
                        ],
                        pageTitle: 'agGrid Table',
                        rule: 'all'
                    }
                },
                // =============================================================================
                // FORMS
                // =============================================================================
                // =============================================================================
                // FORM ELEMENTS
                // =============================================================================
                {
                    path: '/forms/form-elements/select',
                    name: 'form-element-select',
                    component: () => import('./views/forms/form-elements/select/Select.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Select', active: true }
                        ],
                        pageTitle: 'Select',
                        rule: 'all'
                    }
                },
                {
                    path: '/forms/form-elements/switch',
                    name: 'form-element-switch',
                    component: () => import('./views/forms/form-elements/switch/Switch.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Switch', active: true }
                        ],
                        pageTitle: 'Switch',
                        rule: 'all'
                    }
                },
                {
                    path: '/forms/form-elements/checkbox',
                    name: 'form-element-checkbox',
                    component: () => import('./views/forms/form-elements/checkbox/Checkbox.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Checkbox', active: true }
                        ],
                        pageTitle: 'Checkbox',
                        rule: 'all'
                    }
                },
                {
                    path: '/forms/form-elements/radio',
                    name: 'form-element-radio',
                    component: () => import('./views/forms/form-elements/radio/Radio.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Radio', active: true }
                        ],
                        pageTitle: 'Radio',
                        rule: 'all'
                    }
                },
                {
                    path: '/forms/form-elements/input',
                    name: 'form-element-input',
                    component: () => import('./views/forms/form-elements/input/Input.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Input', active: true }
                        ],
                        pageTitle: 'Input',
                        rule: 'all'
                    }
                },
                {
                    path: '/forms/form-elements/number-input',
                    name: 'form-element-number-input',
                    component: () => import('./views/forms/form-elements/number-input/NumberInput.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Number Input', active: true }
                        ],
                        pageTitle: 'Number Input',
                        rule: 'all'
                    }
                },
                {
                    path: '/forms/form-elements/textarea',
                    name: 'form-element-textarea',
                    component: () => import('./views/forms/form-elements/textarea/Textarea.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Form Elements' },
                            { title: 'Textarea', active: true }
                        ],
                        pageTitle: 'Textarea',
                        rule: 'all'
                    }
                },
                // -------------------------------------------------------------------------------------------------------------------------------------------
                {
                    path: '/forms/form-layouts',
                    name: 'forms-form-layouts',
                    component: () => import('@/views/forms/FormLayouts.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Forms' },
                            { title: 'Form Layouts', active: true }
                        ],
                        pageTitle: 'Form Layouts',
                        rule: 'all'
                    }
                },
                {
                    path: '/forms/form-wizard',
                    name: 'extra-component-form-wizard',
                    component: () => import('@/views/forms/form-wizard/FormWizard.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extra Components' },
                            { title: 'Form Wizard', active: true }
                        ],
                        pageTitle: 'Form Wizard',
                        rule: 'all'
                    }
                },
                {
                    path: '/forms/form-validation',
                    name: 'extra-component-form-validation',
                    component: () => import('@/views/forms/form-validation/FormValidation.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Extra Components' },
                            { title: 'Form Validation', active: true }
                        ],
                        pageTitle: 'Form Validation',
                        rule: 'all'
                    }
                },
                {
                  path: '/forms/form-input-group',
                  name: 'extra-component-form-input-group',
                  component: () => import('@/views/forms/form-input-group/FormInputGroup.vue'),
                  meta: {
                      breadcrumb: [
                          { title: 'Home', url: '/' },
                          { title: 'Extra Components' },
                          { title: 'Form Input Group', active: true }
                      ],
                      pageTitle: 'Form Input Group',
                      rule: 'all'
                  }
                },

                // =============================================================================
                // Pages Routes
                // =============================================================================
                {
                    path: '/user-settings',
                    name: 'user-settings',
                    component: () => import('@/views/pages/user-settings/UserSettings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Configurações' },
                            { title: 'Usuário', active: true }
                        ],
                        pageTitle: 'Configurações do Usuário',
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/faq',
                    name: 'page-faq',
                    component: () => import('@/views/pages/Faq.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'FAQ', active: true }
                        ],
                        pageTitle: 'FAQ',
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/knowledge-base',
                    name: 'page-knowledge-base',
                    component: () => import('@/views/pages/KnowledgeBase.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'KnowledgeBase', active: true }
                        ],
                        pageTitle: 'KnowledgeBase',
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/knowledge-base/category',
                    name: 'page-knowledge-base-category',
                    component: () => import('@/views/pages/KnowledgeBaseCategory.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'KnowledgeBase', url: '/pages/knowledge-base' },
                            { title: 'Category', active: true }
                        ],
                        parent: 'page-knowledge-base',
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/knowledge-base/category/question',
                    name: 'page-knowledge-base-category-question',
                    component: () => import('@/views/pages/KnowledgeBaseCategoryQuestion.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'KnowledgeBase', url: '/pages/knowledge-base' },
                            { title: 'Category', url: '/pages/knowledge-base/category' },
                            { title: 'Question', active: true }
                        ],
                        parent: 'page-knowledge-base',
                        rule: 'all'
                    }
                }
            ],
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/login',
                    name: 'login',
                    component: () => import('@/views/pages/login/Login.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/register',
                    name: 'page-register',
                    component: () => import('@/views/pages/register/Register.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/reset-password',
                    name: 'page-reset-password',
                    component: () => import('@/views/pages/ResetPassword.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/lock-screen',
                    name: 'page-lock-screen',
                    component: () => import('@/views/pages/LockScreen.vue'),
                    meta: {
                        rule: 'al'
                    }
                },
                {
                    path: '/pages/comingsoon',
                    name: 'page-coming-soon',
                    component: () => import('@/views/pages/ComingSoon.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'all'
                    }
                },
                {
                    path: '/pages/maintenance',
                    name: 'page-maintenance',
                    component: () => import('@/views/pages/Maintenance.vue'),
                    meta: {
                        rule: 'all'
                    }
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none"
    }
})

router.beforeEach((to, from, next) => {
    if (to.meta.authRequired) {
        if (!localStorage.getItem('accessToken')) {
            router.push({ path: '/login', query: { to: to.path } })
        }
    }
    return next()
})

export default router
